import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Stack,
  StackDivider,
  Box,
  Text,
  Image,
  Divider,
  ButtonGroup,
  Button,
  Wrap,
  Center,
  Flex,
  Spacer,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { transformData } from '../util.js';
import { ServiceCard } from './ServiceCard.js';
import { useParams } from 'react-router-dom';
import { cans } from '../icblast.js';

export function CategoryServices() {
  let [topServices, setTopServices] = useState([]);
  let { id } = useParams();

  useEffect(() => {
    (async () => {
      setTopServices([]);

      let r = await cans.qgig.get_category_services(parseInt(id, 10));
      setTopServices(r);
    })();
  }, [id]);
  if (!topServices.length) return null;
  return (
    <Center>
      <Wrap justify="center">
        {topServices.map((x, idx) => (
          <ServiceCard key={idx} {...x} />
        ))}
      </Wrap>
    </Center>
  );
}
